import { LoadingButton } from "@mui/lab";
import {
    Avatar,
    Box,
    Button,
    Icon,
    IconButton,
    Menu,
    MenuItem,
    Stack,
    Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import {
    CourseDto,
    CourseUserDto,
    CourseService,
} from "../../../api/psc";
import { AccountService as IdentityAccountService } from "../../../api/identity";
import { ConfirmationDialog } from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogContext";
import UpsertEmployeeDialog from "../../employees/dialogs/UpsertEmployeeDialog";
import CourseRegistrationCredentials from "../dialogs/CourseRegistrationCredentials";

export default function CourseEmployeeListItem(props: {
    course: CourseDto;
    item: CourseUserDto;
    onChange: () => void;
}) {
    const { openDialog, closeDialog } = useContext(DialogContext);

    const [requestInProgress, setRequestInProgress] = useState(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const viewCredentials = () => {
        openDialog(
            <CourseRegistrationCredentials
                courseEmployee={props.item}
                course={props.course}
            />
        );
    };

    const registerUser = () => {
        if (!props.item.user?.id) return;
        setRequestInProgress(true);
        CourseService.registerInCourse(
            props.course.id,
            props.item.user.id,
            "1"
        )
            .then((r) => {
                props.onChange();
            })
            .finally(() => {
                setRequestInProgress(false);
            });
    };

    const handleEditUser = () => {
        openDialog(
            <UpsertEmployeeDialog user={props.item.user} />,
            (r) => {
                props.onChange();
            }
        );
    };

    const handleDeleteUser = () => {
        if (!props.item.user?.id) return;
        openDialog(
            <ConfirmationDialog
                title="آیا نسبت به حذف این کاربر اطمینان دارید؟"
                onAccept={() => {
                    IdentityAccountService.removeUser(
                        props.item.user!.id!
                    ).then((r) => {
                        props.onChange();
                    });
                }}
            />
        );
    };

    return (
        <Box>
            <Stack direction="row" spacing={1} alignItems="center">
                <Avatar sx={{ width: 30, height: 30 }} />

                <Stack>
                    <Typography sx={{ flexGrow: 1 }}>
                        {props.item.user?.displayName}
                    </Typography>

                    <Typography sx={{ flexGrow: 1 }}>
                        {props.item.user?.mobileNumber}
                    </Typography>
                </Stack>

                <Box flexGrow={1} />

                {props.item.isRegistered && (
                    <Button
                        onClick={viewCredentials}
                        size="small"
                        variant="outlined"
                        color="warning"
                    >
                        مشاهده اطلاعات ورود
                    </Button>
                )}

                {!props.item.isRegistered && !props.course.isCapacityFull && (
                    <LoadingButton
                        onClick={registerUser}
                        loading={requestInProgress}
                        size="small"
                        variant="contained"
                        color="success"
                    >
                        ثبت نام
                    </LoadingButton>
                )}

                {!props.item.isRegistered && props.course.isCapacityFull && (
                    <LoadingButton
                        disabled
                        size="small"
                        variant="contained"
                        color="success"
                    >
                        تکمیل ظرفیت
                    </LoadingButton>
                )}

                <IconButton onClick={openMenu}>
                    <Icon>more_vertical</Icon>
                </IconButton>

                <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                    <MenuItem onClick={handleEditUser}>ویرایش</MenuItem>
                    <MenuItem onClick={handleDeleteUser}>حذف</MenuItem>
                </Menu>
            </Stack>
        </Box>
    );
}
